(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["liy-review-capture"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pages = document.querySelectorAll('[data-liy-review-capture]');
    if (!pages.length) return;

    const params = new URLSearchParams(window.location.search);
    const fieldMap = {
      product: 'LiyReviewProductHandle',
      product_handle: 'LiyReviewProductHandle',
      product_title: 'LiyReviewProductTitle',
      product_id: 'LiyReviewProductId',
      variant_id: 'LiyReviewVariantId',
      sku: 'LiyReviewSku',
      order: 'LiyReviewOrder',
      customer_id: 'LiyReviewCustomerId',
      email: 'LiyReviewCustomerEmail',
      utm_source: 'LiyReviewUtmSource',
      utm_medium: 'LiyReviewUtmMedium',
      utm_campaign: 'LiyReviewUtmCampaign'
    };

    Object.entries(fieldMap).forEach(([param, id]) => {
      const value = params.get(param);
      const field = document.getElementById(id);
      if (field && value) field.value = value;
    });

    const emailField = document.getElementById('ReviewEmail');
    const emailValue = params.get('email');
    if (emailField && emailValue) emailField.value = emailValue;

    const nameField = document.getElementById('ReviewName');
    const nameValue = params.get('name');
    if (nameField && nameValue) nameField.value = nameValue;

    const pageUrlField = document.getElementById('LiyReviewPageUrl');
    if (pageUrlField) pageUrlField.value = window.location.href;

    const referrerField = document.getElementById('LiyReviewReferrer');
    if (referrerField) referrerField.value = document.referrer;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
